import { Outlet } from "react-router-dom";
import styled from "styled-components";

import { NavBar } from "./NavBar";

// This component fills the remaining space after the nav bar so we can postion things at the bottom of the page
const Page = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  position: relative;
`;

export function PageWithNavBar(): React.ReactElement {
  return (
    <>
      <NavBar />
      <Page>
        <Outlet />
      </Page>
    </>
  );
}
